import { api } from "@/api";
import { AddBettingSelectionParams, BettingSelectionDto } from "@/types/ApiResponses/BettingSelection";

export const addBettingSelection = async (
  params: AddBettingSelectionParams
): Promise<BettingSelectionDto> => {
  const res = await api.client.post(`/betting-selections-new`, params);
  return res.data;
};
